var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from './translate';
import * as yaml from 'js-yaml';
import { constructArgumentCollection, deconstructArgumentCollection } from './arguments';
import { DominoBuilderError, DominoBuilderErrorScope, DominoBuilderErrorSeverity, DominoBuilderErrorType, filterErrors, } from './errors';
import { getIsBlueprintDefinition, objectToNVP } from './helpers';
import { HandleType, } from './types';
export const constructBlueprintReference = (resourceRegistry, derivedFlowSpec, blueprintRegistryClient) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    let blueprintReference;
    const errors = [];
    // should probably support array format here as well similar to action args
    const providedArgs = objectToNVP((_a = derivedFlowSpec.args) !== null && _a !== void 0 ? _a : {});
    const blueprintRegistryEntry = yield blueprintRegistryClient.fetchBlueprintById(derivedFlowSpec.blueprintRef);
    let blueprintSpec;
    if (!blueprintRegistryEntry) {
        errors.push(new DominoBuilderError(DominoBuilderErrorType.BlueprintReferenceError, DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.FATAL, t('errors.invalid_blueprint_reference'), {
            path: `Blueprint`,
        }));
    }
    else {
        const parsedBlueprintYaml = yaml.load(blueprintRegistryEntry.dsl);
        if (!getIsBlueprintDefinition(parsedBlueprintYaml)) {
            return;
        }
        const blueprint = parsedBlueprintYaml.blueprint;
        blueprintSpec = blueprint.spec;
        const argsCollection = yield constructArgumentCollection(resourceRegistry, (_b = blueprint.params) !== null && _b !== void 0 ? _b : [], providedArgs !== null && providedArgs !== void 0 ? providedArgs : [], HandleType.BlueprintArgument);
        blueprintReference = Object.assign(Object.assign({}, blueprintReference), { blueprintId: blueprintRegistryEntry.id, name: blueprintRegistryEntry.name, argsCollection });
    }
    blueprintReference = Object.assign(Object.assign({}, blueprintReference), { errors, getErrorAggregate: (scope, severity) => filterErrors(scope, severity, errors) });
    return [blueprintReference, blueprintSpec];
});
export const deconstructBlueprintReference = (blueprintReference) => {
    return !!blueprintReference.argsCollection
        ? {
            blueprintRef: blueprintReference.blueprintId,
            // blueprint parameters can contain expressions, but will only be able to reference
            // trigger inputs, so action reference handling not needed here
            args: deconstructArgumentCollection(blueprintReference.argsCollection, []),
        }
        : {
            blueprintRef: blueprintReference.blueprintId,
        };
};
//# sourceMappingURL=blueprintReferences.js.map